import { render, staticRenderFns } from "./audioOrder.vue?vue&type=template&id=66f8ae5e&scoped=true"
import script from "./audioOrder.vue?vue&type=script&lang=js"
export * from "./audioOrder.vue?vue&type=script&lang=js"
import style0 from "./audioOrder.vue?vue&type=style&index=0&id=66f8ae5e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66f8ae5e",
  null
  
)

export default component.exports